// src/components/Common/InputField.js
import { styled, TextField, Typography } from "@mui/material";
import React from "react";

const InputField = ({ type, placeholder, name, register,onChange, errorMessage }) => {
  return (
    <>
      <CustomTextField
        type={type}
        placeholder={placeholder}
        name={name} 
        onChange={onChange}
        {...register(name)}
      />
      {errorMessage && <ErrorText>{errorMessage}</ErrorText>}
    </>
  );
};

export default InputField;

const CustomTextField = styled(TextField)(() => ({
  width: "100%",
  border: "1px solid #DADADA",
  borderRadius: "7px",
  "& .MuiInputBase-input": {
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "1",
    color: "#2C2C2E",
    padding: "14px 20px",
  },
  "& fieldset": {
    border: "none",
  },
}));
const ErrorText = styled(Typography)(() => ({
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "1.445",
  color: "#ff0000",
  marginTop: "5px",
}));
